document.querySelectorAll('#practice-test .question input[type="radio"]').forEach(function (radio) {
  radio.addEventListener('change', function () {
    var question = this.closest('.question');
    if (this.value === 'y') {
      question.querySelector('.alert.red').classList.add('d-none');
      question.querySelector('.alert.green').classList.remove('d-none');
    } else {
      question.querySelector('.alert.red').classList.remove('d-none');
      question.querySelector('.alert.green').classList.add('d-none');
    }
  });
});
